module.exports = __webpack_public_path__ + "static/media/bgr-paper-tear-short.f5f3a4e8.webp";